<button class="btn  fw-bold trend-button" [ngClass]="jsonClasses" type="button"
  (click)="onUpgradeClick()">
  <i class="mdi mdi-update"></i>
  @if (expired) {
  Seu período de teste expirou. Ative um plano para continuar usando todos os recursos!
  } @else if (daysRemaining === 0) {
  Último dia do seu período de teste. Ative um plano para não perder acesso!
  } @else if (daysRemaining === 1) {
  Amanhã é o último dia do seu período de teste!
  } @else {
  Faltam {{ daysRemaining }} dias para o fim do seu período de teste!
  }
</button>